import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { NewRequestFormService } from 'src/app/services/new-request-form.service';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-new-request-error-snackbar',
  templateUrl: './new-request-error-snackbar.component.html',
})
export class NewRequestErrorSnackbarComponent implements OnInit {
  objectDataList: any[] = [];
  faCircleXmark = faCircleXmark;
  onClose$: Subject<boolean>;
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public _snackRef: MatSnackBarRef<NewRequestErrorSnackbarComponent>,
    private readonly newRequestFormService: NewRequestFormService
  ) {
    this.objectDataList = data?.dataList ?? [];
    this.onClose$ = data.onClose$;
    this.checkList();
  }

  ngOnInit(): void {
    this.checkList();
  }

  retryNewRequest(index: number) {
    if (this.objectDataList[index]) {
      this.newRequestFormService.newRequest(
        this.objectDataList[index].formData
      );
      this.deleteMessage(index);
    }
  }

  deleteMessage(index: number) {
    this.objectDataList.splice(index, 1);
    this.checkList();
  }

  checkList() {
    if (this.objectDataList.length == 0) this.close();
  }

  close() {
    this._snackRef.dismiss();
    this.onClose$.next(true);
  }
}
